import ConfirmationNumberOutlinedIcon from '@mui/icons-material/ConfirmationNumberOutlined';
import OpenInNewOutlinedIcon from '@mui/icons-material/OpenInNewOutlined';
import AdminResourceCrudPage from './components/AdminResourceCrudPage';

const AdminCaseTicketsPage = () => {
  return (
    <AdminResourceCrudPage
      title="External Case Tickets"
      subtitle="Observe ticket synchronization state across Jira, GitHub, and webhook connectors."
      icon={ConfirmationNumberOutlinedIcon}
      endpoint="/api/admin/case-tickets/"
      allowCreate={false}
      allowEdit={false}
      allowDelete={false}
      columns={[
        { key: 'updated_at', label: 'Updated', render: (row) => new Date(row.updated_at).toLocaleString() },
        { key: 'case_title', label: 'Case' },
        { key: 'provider', label: 'Provider' },
        { key: 'connector_name', label: 'Connector' },
        { key: 'external_id', label: 'External ID' },
        { key: 'status', label: 'Status' },
        { key: 'error_message', label: 'Error', render: (row) => row.error_message || '-' }
      ]}
      rowActions={[
        {
          label: 'Open ticket',
          icon: OpenInNewOutlinedIcon,
          visible: (row) => Boolean(row.external_url),
          onClick: async (row) => {
            if (row.external_url) window.open(row.external_url, '_blank', 'noopener,noreferrer');
          }
        }
      ]}
    />
  );
};

export default AdminCaseTicketsPage;
